<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyWork" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button><Button type="primary" @click="exportAll" class="chaxun">导出</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">
      <ul slot-scope="{ row, index }" slot="pickupAddress">
        <li style="margin-bottom: 10px;" v-for="(x, index) in row.pickupAddress2" :key='index'>
          <strong>{{ x.split('_')[0] }}</strong>
          <p>{{ x.split('_')[1] }}</p>
        </li>
      </ul>
      <ul slot-scope="{ row, index }" slot="unloadAddress">
        <li style="margin-bottom: 10px;" v-for="(x, index) in row.unloadAddress2" :key='index'>
          <strong>{{ x.split('_')[0] }}</strong>
          <p>{{ x.split('_')[1] }}</p>
        </li>
      </ul>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
  </div>
</template>

<script>
var categorys = [];
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "日期",
          key: "createTime2",
        },
        {
          title: "订单号",
          key: "ono",
        },
        {
          title: "客户名称",
          key: "customer",
        },
        {
          title: "大陆司机",
          key: "driver",
        },
        {
          title: "香港司机",
          key: "driverHk",
        },
        {
          title: "大陆司机工资",
          key: "money",
        },
        {
          title: "香港司机工资",
          key: "moneyHk",
        },
        {
          title: "运输费用",
          key: "transportMoney",
        },
        {
          title: "大陆车牌",
          key: "carNo",
        },
        {
          title: "香港车牌",
          key: "carNoHk",
        },
        {
          title: "车辆类型",
          key: "carType",
        },
        {
          title: "提货地址",
          slot: "pickupAddress",
          width: 300
        },
        {
          title: "口岸",
          key: "customs",
        },
        {
          title: "卸货地址",
          slot: "unloadAddress",
          width: 300
        },
        {
          title: "数量/件",
          key: "amount",
        },
        {
          title: "重量/kgs",
          key: "weight",
        },
        {
          title: "卡板/板",
          key: "pnumber",
        },
        {
          title: "体积/cbm",
          key: "volume",
        },
      ],
      tableData: [],

      searchItem: {
        keyWork: "",
        startTime: "",
        endTime: "",
        driver: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,4,0",
        },
        /* {
          title: "司机姓名",
          key: "driver",
          type: "Input",
        }, */
      ],
      total: 0,
      forms: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-fms/accountsReceivable/driverSalaryList",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].pickupAddress2 = data[i].pickupAddress == null ? [] : data[i].pickupAddress.split('|');
          data[i].unloadAddress2 = data[i].unloadAddress == null ? [] : data[i].unloadAddress.split('|');
          data[i].createTime2=this.utils.time(data[i].createTime,'yymmdd');
        }
        /* for (const i in data) {
          data[i].type = String(data[i].type);
          data[i].type2 = this.$t("roleType." + data[i].type);
          var t = data[i].extend;
          for (const j in t) {
            data[i]["extend_" + j] = t == null ? "" : t[j];
          }
        } */
        this.tableData = data;
        console.log('司机工资', data);
      });
    },

    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    exportAll() {
      var params = [
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
      ];
      this.utils.exportData(
        this.axios.ipPort +
        "/cloud-tms-server-fms/accountsReceivable/driverSalaryExportExcel",
        params
      );
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/report/kehuqiankuan.vue